import { isSidebarRecentItemsFilter } from '#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/sidebar-recent-items-state/recentItemsTypes.js';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
// Every recents consumer follows this selection so they share one live feed.
export function useSidebarRecentsFilter(isEligible) {
    const [storedFilter, setFilter] = useLocalUserSettings('sidebarRecentItemsFilter', 'all');
    const filter = isEligible && isSidebarRecentItemsFilter(storedFilter) ? storedFilter : 'all';
    return { filter, setFilter, canFilter: isEligible };
}
//# sourceMappingURL=useSidebarRecentsFilter.js.map